import type { DateType } from "../types";

export function classNames(...classes: (false | null | undefined | string)[]) {
  return classes.filter(Boolean).join(" ");
}

export function generateArrayNumber(start = 0, end = 0) {
  const array = [];
  for (let i = start; i <= end; i++) {
    array.push(i);
  }

  return array;
}

export function shortString(value: string, limit = 3) {
  return value.slice(0, limit);
}

export function ucFirst(value: string) {
  return `${(value[0] || "")?.toUpperCase()}${(value || "")?.slice(1, value.length)}`;
}

export const updateLimitDate = (
  limitDays: number,
  firstDateSelected: DateType,
  secondDateSelected?: DateType,
  minDateDefault?: DateType,
  maxDateDefault?: DateType,
): { minDate: DateType | undefined; maxDate: DateType | undefined } => {
  const DAY_IN_MS = 24 * 60 * 60 * 1000;

  if (firstDateSelected && !secondDateSelected) {
    const minFromStart =
      (firstDateSelected?.getTime() || 0) - limitDays * DAY_IN_MS;
    const minDate = new Date(
      Math.max(minFromStart, minDateDefault?.getTime() ?? minFromStart),
    );
    const maxFromStart =
      (firstDateSelected?.getTime() || 0) + limitDays * DAY_IN_MS;
    const maxDate = new Date(
      Math.min(
        maxFromStart,
        new Date().getTime(),
        maxDateDefault?.getTime() ?? maxFromStart,
      ),
    );

    return {
      minDate,
      maxDate,
    };
  }

  return { minDate: minDateDefault, maxDate: maxDateDefault };
};
